/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_ApproveInputs */

const en_follow_approve = /** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const es_follow_approve = /** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar`)
};

const fr_follow_approve = /** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver`)
};

const de_follow_approve = /** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zulassen`)
};

const id_follow_approve = /** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui`)
};

/** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */
const ja_follow_approve = en_follow_approve;

/** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */
const zh_follow_approve = en_follow_approve;

/** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */
const ar_follow_approve = en_follow_approve;

/** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */
const it_follow_approve = en_follow_approve;

/** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */
const ru_follow_approve = en_follow_approve;

/** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */
const pt_follow_approve = en_follow_approve;

/** @type {(inputs: Follow_ApproveInputs) => LocalizedString} */
const ko_follow_approve = en_follow_approve;

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Follow_ApproveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_approve = /** @type {((inputs?: Follow_ApproveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_ApproveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_approve(inputs)
	if (locale === "es") return es_follow_approve(inputs)
	if (locale === "fr") return fr_follow_approve(inputs)
	if (locale === "de") return de_follow_approve(inputs)
	if (locale === "ja") return ja_follow_approve(inputs)
	if (locale === "zh") return zh_follow_approve(inputs)
	if (locale === "ar") return ar_follow_approve(inputs)
	if (locale === "id") return id_follow_approve(inputs)
	if (locale === "it") return it_follow_approve(inputs)
	if (locale === "ru") return ru_follow_approve(inputs)
	if (locale === "pt") return pt_follow_approve(inputs)
	return ko_follow_approve(inputs)
});